import { Alert, Box, Link } from "@mui/material";
import { AnimatePresence, motion, Variants } from "motion/react";
import {
  IncidentIndicator,
  MONDOO_STATUS_PAGE_URL,
} from "~/components/IncidentBanner/useIncidentBanner";
import { useIncidentBannerColors } from "~/components/IncidentBanner/useIncidentBannerColors";
import { useAuth } from "~/login/provider";

const bannerVariants: Variants = {
  closed: {
    opacity: 0,
    height: 0,
    transition: {
      ease: "easeIn",
      duration: 0.225,
    },
  },
  open: {
    opacity: 1,
    height: "auto",
    transition: {
      ease: "easeOut",
      duration: 0.325,
    },
  },
};

const getSeverity = (incidentIndicator: IncidentIndicator) => {
  switch (incidentIndicator) {
    case IncidentIndicator.MAINTENANCE:
      return "info";
    default:
      return "warning";
  }
};

export function IncidentBanner() {
  const { incident } = useAuth();
  const bannerColors = useIncidentBannerColors(incident?.data?.indicator);

  const hasIncident = incident.data.indicator !== IncidentIndicator.NONE;

  if (!hasIncident || !incident.showIncidentBanner) {
    return null;
  }

  return (
    <AnimatePresence mode="wait">
      <Box
        component={motion.div}
        variants={bannerVariants}
        initial="closed"
        animate="open"
        exit="closed"
        sx={{
          ...bannerColors,
          zIndex: (theme) => theme.zIndex.drawer + 1,
          position: "fixed",
          width: "100%",
        }}
      >
        <Alert
          id="incident-info"
          variant="filled"
          severity={getSeverity(incident?.data?.indicator)}
          onClose={incident?.onCloseIncidentBanner}
          sx={{
            borderRadius: 0,
            paddingTop: "4px",
          }}
        >
          <Link target="_blank" href={MONDOO_STATUS_PAGE_URL}>
            {incident?.data?.msg}
          </Link>
        </Alert>
      </Box>
    </AnimatePresence>
  );
}
